const shimmer =
  "animate-pulse rounded-[1.2rem] bg-[linear-gradient(135deg,rgba(255,178,91,0.2),rgba(255,139,31,0.1))] dark:bg-[linear-gradient(135deg,rgba(255,178,91,0.18),rgba(229,106,0,0.12))]";

const SkeletonCard = () => (
  <div className="w-full max-w-[268px] cursor-pointer group mx-auto">
    <div className="portal-page-card rounded-[1.6rem] p-3 md:p-4">
      <div
        className={`h-[100px] w-full rounded-[1.35rem] md:h-[140px] ${shimmer}`}
      ></div>
      <div className={`mx-auto mt-3 h-4 w-3/4 ${shimmer}`}></div>
    </div>
  </div>
);

const SkeletonList = ({ number = 4, top = false }) => (
  <div className="grid">
    {top ? (
      <div className="portal-page-card mb-4 rounded-[1.4rem] p-3">
        <div className={`h-11 w-full ${shimmer}`}></div>
      </div>
    ) : null}
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4">
      {Array(number)
        .fill(0)
        .map((_, index) => (
          <SkeletonCard key={index} />
        ))}
    </div>
  </div>
);

export default SkeletonList;
